// src/components/common/Toast.jsx
// 발송 완료 등 피드백 토스트

import React from 'react';
import { useApp } from '../../context/AppContext';

export default function Toast() {
  const { state } = useApp();
  const { toast } = state;

  if (!toast) return null;

  const icons = {
    success: '✓',
    error: '✕',
    info: 'ℹ',
  };

  return (
    <div className="toast-container">
      <div className={`toast toast-${toast.type || 'success'}`}>
        <span style={{ fontWeight: 700, fontSize: 16 }}>
          {icons[toast.type] || icons.success}
        </span>
        <span>{toast.message}</span>
      </div>
    </div>
  );
}
